import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 灯组列表接口
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	lightGroupList( params={} ) {
		return request({
	    url: baseUrl + '/device/lampGroup',
	    method: 'GET',
	    params
	  })
	},
	/**
	 * 灯组添加接口
	**/
    lightGroupAdd(data) {
		return request({
	    url: baseUrl + '/device/lampGroup',
	    method: 'POST',
	    data
	  })
	},
	/**
	 * 灯组编辑接口
	**/
	lightGroupEdit(id,data){
		return request({
			url: baseUrl + '/device/lampGroup/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 删除灯组接口
	**/
	lightGroupDel(id){
		return request({
			url: baseUrl + '/device/lampGroup/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 路灯分配-分配或者取消路灯
	 * @param {type} 0未分配1已分配
	 * @param {lamp_ids} 1,2,3 所选设备
	 * @param {group} 路灯ID
	**/
	groupFen(data){
		return request({
			url: baseUrl + '/device/GroupFen',
			method:'POST',
			data
		})
	},

	/**
	 * 灯组控制 
	 * @param {id} 灯组ID
	 * @param {data:{light}} 亮度
	**/
	groupControl(id,data){
		return request({
			url: baseUrl + '/device/groupControl/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 该分组下的路灯
	 * @param {lamp_group} 分组ID
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	getGroupLamps(params={} ) {
		return request({
	    url: baseUrl + '/device/getGroupLamps',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 未解绑的路灯
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	getUnassignedGroupLamps( params={} ) {
		return request({
	    url: baseUrl + '/device/getUnassignedGroupLamps',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 路灯绑定分组
	 * @param {lamp_group} 分组ID
	 * @param {lamp_id} 路灯ID
	**/
    gorupCommand(lamp_group,data) {
		return request({
	    url: baseUrl + '/device/command/'+lamp_group,
	    method: 'POST',
	    data
	  })
	},

	/**
	 * 灯组解绑路灯
	**/
	gorupUntiecommand(id){
		return request({
			url: baseUrl + '/device/Untiecommand/'+id,
			method: 'POST'
		})
	}
}